export default {
    computed: {
        orderFinanceModel() {
            return {}
        },
        appliedDiscounts() {
            return this.orderFinanceModel?.applied_discounts || {}
        },
        /*  
        originalUserSum() {
            return this.appliedDiscounts?.original_user_sum
        },
        originalCompanySum() {
            return this.appliedDiscounts?.original_user_sum
        },
        */
        originalDeliveryPrice() {
            return this.appliedDiscounts?.original_delivery_price
        },
        originalTotalPrice() {
            return this.appliedDiscounts?.original_total_price
        },
        referralDiscount() {
            return this.appliedDiscounts?.applied_referral?.referral_discount || 0
        },
        restaurantDiscount() {
            return this.appliedDiscounts?.applied_restaurant_discount?.item_discount || 0
        },
        /*    
        deliveryAreaDiscount() {
            return this.appliedDiscounts?.applied_delivery_area?.delivery_discount
        },
        deliveryAreaOverride() {
            return this.appliedDiscounts?.applied_delivery_area?.override
        }, 
        */
        promotionUserDiscount() {
            return this.appliedDiscounts?.applied_promotion?.user_discount || 0
        },
        /*   
        promotionUserDeliveryDiscount() {
            return this.appliedDiscounts?.applied_promotion?.user_delivery_discount
        }, 
        */
        promotionCompanyDiscount() {
            return this.appliedDiscounts?.applied_promotion?.company_discount || 0
        },
        /* 
        promotionCompanyDeliveryDiscount() {
            return this.appliedDiscounts?.applied_promotion?.company_delivery_discount
        },
        promotionDiscount() {
            return this.appliedDiscounts?.applied_promotion?.total_discount
        }, 
        */
        couponItemDiscount() {
            return this.appliedDiscounts?.applied_coupon?.item_discount || 0
        },
        /*  
       couponDelvieryDiscount() {
            return this.appliedDiscounts?.applied_coupon?.delivery_discount
        },
        couponUserDiscount() {
            return this.appliedDiscounts?.applied_coupon?.user_discount
        }, 
        */
        couponDiscount() {
            return this.appliedDiscounts?.applied_coupon?.total_discount
        },
        companyServiceFee() {
            return this.orderFinanceModel.company_service_fee
        },
        totalPrice() {
            return this.orderFinanceModel.price_sum
        },
        subTotal() {
            return this.orderFinanceModel.price_sum_items
        },
        paidByCompany() {
            return this.orderFinanceModel.price_sum_firm
        },
        paidByUser() {
            return this.orderFinanceModel.price_sum_user
        },
        deliveryPrice() {
            return this.orderFinanceModel.price_delivery || 0
        },
        deliveryPriceHighlight() {
            return this.deliveryPrice < this.originalDeliveryPrice
        },
    },
}
